export const SOCIAL_PLATFORMS = {
  facebook: {
    value: 'facebook',
    label: 'Facebook',
    iconUrl: 'https://cdn-icons-png.flaticon.com/512/733/733547.png',
    placeholder: 'https://facebook.com/yourpage',
  },
  twitter: {
    value: 'twitter',
    label: 'X / Twitter',
    iconUrl: 'https://cdn-icons-png.flaticon.com/512/5969/5969020.png',
    placeholder: 'https://x.com/yourhandle',
  },
  instagram: {
    value: 'instagram',
    label: 'Instagram',
    iconUrl: 'https://cdn-icons-png.flaticon.com/512/733/733558.png',
    placeholder: 'https://instagram.com/yourprofile',
  },
  linkedin: {
    value: 'linkedin',
    label: 'LinkedIn',
    iconUrl: 'https://cdn-icons-png.flaticon.com/512/733/733561.png',
    placeholder: 'https://linkedin.com/in/yourprofile',
  },
  youtube: {
    value: 'youtube',
    label: 'YouTube',
    iconUrl: 'https://cdn-icons-png.flaticon.com/512/1384/1384060.png',
    placeholder: 'https://youtube.com/@channel',
  },
  whatsapp: {
    value: 'whatsapp',
    label: 'WhatsApp',
    iconUrl: 'https://cdn-icons-png.flaticon.com/512/733/733585.png',
    placeholder: 'https://wa.me/1234567890',
  },
  github: {
    value: 'github',
    label: 'GitHub',
    iconUrl: 'https://cdn-icons-png.flaticon.com/512/733/733553.png',
    placeholder: 'https://github.com/yourusername',
  },
  tiktok: {
    value: 'tiktok',
    label: 'TikTok',
    iconUrl: 'https://cdn-icons-png.flaticon.com/512/3046/3046121.png',
    placeholder: 'https://tiktok.com/@yourhandle',
  },
  custom: {
    value: 'custom',
    label: 'Custom Icon',
    iconUrl: 'https://cdn-icons-png.flaticon.com/512/1004/1004300.png',
    placeholder: 'https://...',
  },
};

export const SOCIAL_PLATFORM_OPTIONS = Object.values(SOCIAL_PLATFORMS).map(
  (p) => ({
    value: p.value,
    label: p.label,
  }),
);

export function getSocialIconUrl(platform, customIconUrl) {
  if (platform === 'custom' && customIconUrl) {
    return customIconUrl;
  }
  return (
    SOCIAL_PLATFORMS[platform]?.iconUrl ||
    'https://cdn-icons-png.flaticon.com/512/1004/1004300.png'
  );
}

export function getSocialPlaceholder(platform) {
  return SOCIAL_PLATFORMS[platform]?.placeholder || 'https://...';
}
